/* cSpell:disable */
import { styled } from '../../../../../theme';
// import { CoreStateCompany } from '../../../store/core/types';
// interface StylesProps {
// 	company?: CoreStateCompany;
// }
export const ModelContentContainer = styled.div`
	margin-bottom: 25px;
`;
// stylelint-disable
export const ModalInnerContainer = styled.div`
	text-align: center;

	/* ​ .ui.image.modalImage {
		max-height: 60px;
		margin: 0 auto 20px auto;
	} */
`;
// stylelint-enable
// styled.div<StylesProps>`
// export const StyledIconContainer = styled.div<any>`
// 	position: relative;
// 	margin-bottom: 0px;
// 	${(props: any) => /*props.company === CoreStateCompany.BCP &&*/ `margin-top: -16px;`}

// 	> div {
// 		/* ${(props: any) => props.company === CoreStateCompany.AB && `position: absolute;`}
// 		${(props: any) => props.company === CoreStateCompany.AB && `top: -76px;`} */
// 		margin: auto;
// 		left: 0;
// 		right: 0;
// 		text-align: center;
// 		z-index: 10;
// 		${(props: any) => /*props.company === CoreStateCompany.BCP &&*/ `width: 200px;`}
// 		${(props: any) => /*props.company === CoreStateCompany.BCP &&*/ `height: 150px;`}

// 		> img {
// 			${(props: any) => /*(props.company === CoreStateCompany.BCP ?*/ `width: 200px;` /*: `width: 64px;`)*/}
// 			${(props: any) => /*(props.company === CoreStateCompany.BCP ?*/ `height: 150px;` /*: `width: 64px;`)*/}
// 		}
// 	}
// `;

export const StyledIconContainer = styled.div<any>`
	position: relative;
	margin-bottom: 0px;
	${(props: any) => `margin-top: -16px;`}

	> div {
		margin: auto;
		left: 0;
		right: 0;
		text-align: center;
		z-index: 10;
		${(props: any) => `width: 200px;`}
		${(props: any) => `height: 150px;`}

		> img {
			${(props: any) => `width: 200px;`}
			${(props: any) => `height: 150px;`}
		}
	}
`;
